import React from 'react';
import { ColumnDef } from '@tanstack/react-table';
import { useParams } from 'react-router-dom';
import { useQuery, useMutation } from '@apollo/client';

import { TGoc } from '../../../lib/types';
import { GOC_STATUS_ENUM } from '../../../lib/constants/dbConstants';
import { GET_GOC, UPDATE_GOC } from '../../../graph-queries/tar/job';

import AspectsTable from '../AspectsTable/AspectsTable';
import { authorCell } from '../AspectsTable/util';
import classes from './JobAspects.module.scss';
import GocForm from '../GocFrom/GocForm';
import { useHasTarAdminAccess, useHasUserAccess } from '../../../lib/util/auth';

const JobGoc: React.FC = () => {
  const hasUserAccess = useHasUserAccess();
  const hasTarAdminAccess = useHasTarAdminAccess();
  const { jobId: param } = useParams();
  const jobId = parseInt(param || '-1');

  const { data: gocData } = useQuery(GET_GOC, {
    variables: { jobId },
    skip: !jobId || jobId == -1,
  });

  const [updateGoc] = useMutation(UPDATE_GOC, {
    refetchQueries: [GET_GOC],
  });

  const onEditSubmit = (goc: TGoc) => {
    const { updatedBy, updatedAt, ...input } = goc;
    return updateGoc({ variables: { input } });
  };

  const columns: ColumnDef<TGoc>[] = [
    {
      header: 'SH1',
      accessorKey: 'sh1',
      enableSorting: false,
    },
    {
      header: 'MC1',
      accessorKey: 'mc1',
      enableSorting: false,
    },
    {
      header: 'Status',
      accessorKey: 'status',
      enableSorting: false,
      accessorFn: (row) => GOC_STATUS_ENUM[row.status],
    },
    {
      header: 'Comments',
      accessorKey: 'comments',
      enableSorting: false,
    },
    {
      header: 'Last Updated',
      accessorKey: 'updatedAt',
      cell: authorCell,
    },
  ];

  return (
    <AspectsTable<TGoc>
      aspectName="GOC"
      columns={columns}
      data={gocData ? [gocData.gocByJobId as unknown as TGoc] : []}
      renderEditForm={(onClose, defaultValue) => (
        <GocForm
          defaultValues={defaultValue}
          onSubmit={onEditSubmit}
          onClose={onClose}
          type={'edit'}
        />
      )}
      creationDisabled={!hasUserAccess}
      getRowMutationDisabled={(_row) => !hasUserAccess}
      getRowDeletionDisabled={(_row) => !hasTarAdminAccess}
      hideSelectionColumn
      renderBare
      title={<div className={classes.title}>GOC</div>}
    />
  );
};

export default JobGoc;
